<template>
	<v-container>
		<v-row>
			<v-col 
				xl 	 = "12" 
				lg 	 = "12" 
				md 	 = "12" 
				sm 	 = "12" 
				cols = "12"
			>
				<v-card outlined>
					<v-card-title 
						v-text = "$ml.get('user_list')" 
						class  = "justify-center pa-0 caption primary white--text"
					></v-card-title>
					<v-divider></v-divider>
					<v-card-text>
						<v-card outlined>
							<v-data-table 
								dense
								:headers 			 = "header"
								:items 				 = "list"
								 class 				 = "elevation-5"
			  					:options.sync 		 = "options"
							   	:server-items-length = "total"
							   	:footer-props 		 = "{
							   		showFirstLastPage   : true,
							   		itemsPerPageOptions : [15, 30],
							   		showCurrentPage     : true,
							   		
							   	}"
							 
							>
								<template v-slot:item.actions="{ item }">
									
									<v-btn-toggle dense>
										<!-- <v-btn x-small @click="">
											<v-icon small color="primary">mdi-pencil</v-icon>
										</v-btn> -->
										<v-btn 
											x-small 
											@click = "del(item.id, false)"
											v-if   = "currentUser.user.roleId < 3"
											v-show = "show.delete_user"
										>
											<v-icon 
												small 
												color = "error"
											> 
												mdi-delete
											</v-icon>
										</v-btn>
									</v-btn-toggle>
											
								</template>
							</v-data-table>
						</v-card>
					</v-card-text>
					<!-- <v-divider></v-divider>
					<v-card-actions>
						
					</v-card-actions> -->
				</v-card>
			</v-col>
		</v-row>
		<v-dialog 
			v-model = "dialog" 
			width 	= "300"
		>
			<v-card outlined>
				<v-card-title 
					v-text = "$ml.get('confirm')" 
					class  = "justify-center pa-0 caption warning"
				>
				</v-card-title>
				<v-divider></v-divider>
				<v-card-text>
					<p class = "caption mb-0">
						{{ $ml.get('ms_del') }}
					</p>
				</v-card-text>
				<v-divider></v-divider>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn
						x-small 
						color  = "primary"
						v-text = "$ml.get('confirm')"
						@click = "del(confirm_item, true)"
					>
					</v-btn>
					<v-btn 
						x-small 
						color  = "error" 
						v-text = "$ml.get('close')"
						@click = "dialog=false"
					></v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<notifications
			v-if 			 	= "info_to_modal"
			:info 				= "info_to_modal"
			@confirm_message  	= "confirm_del($event)"
			@close_snack_dialog = "info_to_modal = $event"
		></notifications>
	</v-container>
</template>
<script>
import axios from 'axios'
import notifications from '@/components/info/notifications.vue'
import EventBus from '@/event-bus'
	export default{
		name: 'user_list',
		components:{
			notifications
		}, // components
		data: vm => ({
			header:[
				{text: vm.$ml.get('id'), value: 'id' , align: 'center'},
				{text: vm.$ml.get('email'), value: 'email', align: 'center'},
				{text: vm.$ml.get('role'), value: 'role.name', align: 'center'},
				{text: vm.$ml.get('actions'), value: 'actions' , align: 'center'}
			],
			list: [
			// {'id': 0, 'name': "User Operator",'email': "operator@ebenezer.com" ,'type': "Operator"},
			// {'id': 1, 'name': "User Admin",'email': "admin@ebenezer.com" , 'type': "Admin"},
			// {'id': 2, 'name': "User SuperUser", 'email': "SuperUser@ebenezer.com" , 'type': "SuperUser"},
			],
			options 		: { itemsPerPage: 30},
			total 			: 0,
			dialog 			: false,
			confirm_item 	: null,
			info_to_modal 	: null,
			show 			: {
				delete_user : true,
			}
		}),
		created(){
			// this.list_user();
			let modul = this.$store.getters["auth/permission"](this.$route.name || "user", "", "user");
			if (modul) {
				if (!modul.can_delete) { this.show.delete_user = false }
			}
		}, // created 

		watch:{
			options:{
				handler(){
					this.list_user();					
				},
				deep: true,
			}, //options

		}, // watch
		methods:{
			list_user(){
				const  { page, itemsPerPage } = this.options;
				let pg = 1, sw = 0;
				if (itemsPerPage == 15) {
					if (page % 2 == 0) {
						pg = (page / 2);
						sw = 2;
					}else{
						pg = parseInt(page/2)+1;
						sw = 1;
					}
				}else{
					pg = page
				}
				const api = this.$URL + '/api/v1/users/?page=' + pg;
				let jwt;
				if (localStorage.getItem('user')) {		    	
		    		jwt = JSON.parse(localStorage.getItem('user'));		    
		    	}
				//https://github.com/axios/axios
				// console.log(jwt.jwt, 'jwt');
		  		// let headers ={
		  		// 	"Authorization": "Bearer " + jwt.jwt,
		  		// 	"Content-Type": "application/json"
		  		// }
				axios.get( api, {
					headers
					:{
		  				"Authorization": "Bearer " + jwt.jwt,
		  				"Content-Type": "application/json"
		  			}
		  		}).then(
					response => {
						let items = response.data.rows;
						localStorage.setItem('list_users', JSON.stringify(items));
						this.total = parseInt(response.data.count);
						if (itemsPerPage <= 15) {
							items = items.slice((sw - 1) * itemsPerPage, sw  + itemsPerPage );
						}
						items.sort(function(a,b){
						  // Turn your strings into dates, and then subtract them
						  // to get a value that is either negative, positive, or zero.
						  return    b.id - a.id;
						});
						this.list = items;

					}).catch( 
					error => {
						console.log(error, 'error')
					})
			},
			edit(){

			},
			del(index , confirm){
				
				if (!confirm) {
					this.confirm_item = index;
					// console.log(this.confirm_item, 'confirm_del');
					this.dialog = true;
				}else{
					let api = this.$URL + '/api/v1/users/' + index;
					let jwt;
					if (localStorage.getItem('user')) {		    	
			    		jwt = JSON.parse(localStorage.getItem('user'));		    
			    	}
					axios.delete(api,{
			          headers
			          :{
			              "Authorization": "Bearer " + jwt.jwt,
			              "Content-Type": "application/json"
			            }
			          }).then( res =>{
			          	
						// this.list.splice(index,1);
						this.confirm_item = null;
						this.dialog 	  = false;
						this.info_to_modal = { 
							snack : true, 
							type  : false,
							color : 'success',
							info  : this.$ml.get('deleted'),
						}
						this.list_user();
						this.$EventBus.$emit('notifications_modal',{
							type : 'deleted'
						})
					}).catch( er => {
						console.log(er, 'error');
					})
				}
			}, //del 
		},//methods
		computed:{
			currentUser() {		      
		      return this.$store.state.auth.user;
		  }, // current User
		}, // computed
		mounted(){
			EventBus.$on('new_user', (actions) =>{
				this.list_user();

			})
		
		}, // mounted

	};
</script>